import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const RULES_POST_REQUEST = 'POST_RULES_REQUEST';
export const RULES_POST_FAILURE = 'POST_RULES_FAILURE';
export const RULES_POST_SUCCESS = 'POST_RULES_SUCCESS';

export const postRules = (data) => {
    return function(dispatch) {
        dispatch(postRuleRequest());
        return axios(apiRequestOptions(apiPath.RULES.POST, data))
            .then(transformHttpResponse)
            .then(response => dispatch(postRuleSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postRuleFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postRuleRequest = () => {
    return {
        type: RULES_POST_REQUEST,
    }
};

const postRuleFailure = (error) => {
    return {
        type: RULES_POST_FAILURE,
        error,
    }
};

const postRuleSuccess = (rule) => {
    return {
        type: RULES_POST_SUCCESS,
        rule,
    }
};